import React, { useState, useCallback } from 'react';
import { Input, ButtonToolbar, Button } from 'rsuite';
import _ from 'lodash';

import { JSONSchemaToLetsForm } from '../helpers/json-schema-to-lets-form';

import './import-json-schema-modal.scss';

const ImportJsonSchemaModal = ({ onChange, onCancel, onSubmit }) => {
  const [code, setCode] = useState('');
  const [errors, setErrors] = useState();
  const [warnings, setWarnings] = useState();
  const [form, setForm] = useState();

  const handleChange = useCallback(
    value => {
      setCode(value);
      let json;
      try {
        json = JSON.parse(value)
      } catch (e) {
        setErrors(['Invalid JSON']);
        setForm(null);
        onChange(null);
        setWarnings(null);
        return;
      }

      const { form, errors, warnings } = JSONSchemaToLetsForm(json);
      setForm(form);
      setErrors(errors);
      setWarnings(warnings);

      console.log(form);
      console.log(warnings, errors)

    },
    [onChange]
  );

  const handleImportForm = useCallback(
    () => {
      onSubmit({
        type: 'import',
        form
      });
    },
    [onSubmit, form]
  );

  const handleMergeForm = useCallback(
    () => {
      onSubmit({
        type: 'merge',
        form
      });
    },
    [onSubmit, form]
  );

  return (
    <div className="lf-import-json-schema">
      {!_.isEmpty(errors) && (
        <div className="errors">
          <b>JSON Schema Errors</b><br/>
          <div>
            {errors.map((errorMsg, idx) => (
              <div key={idx}>{errorMsg}</div>
            ))}
          </div>
        </div>
      )}
      {!_.isEmpty(warnings) && (
        <div className="warnings">
          <b>JSON Schema Warnings</b><br/>
          <div>
            {warnings.map((warningMsg, idx) => (
              <div key={idx}>{warningMsg}</div>
            ))}
          </div>
        </div>
      )}
      <Input
        as="textarea"
        style={{ width: '100%', height: '400px' }}
        value={code}
        onChange={handleChange}>
      </Input>
      <ButtonToolbar className="buttons">
        <Button
          appearance="primary"
          disabled={form == null}
          onClick={handleImportForm}
        >Import form</Button>
        <Button
          disabled={form == null}
          appearance="primary"
          onClick={handleMergeForm}
        >Import and merge</Button>
        <Button
          onClick={onCancel}
        >Cancel</Button>
      </ButtonToolbar>
    </div>
  );
};

export { ImportJsonSchemaModal };
